import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themesAnimated from '@amcharts/amcharts4/themes/animated'

import { emptyPieColor } from '@/utils/constants'

am4core.useTheme(am4themesAnimated)

const setPieSeries = pieSeries => {
  pieSeries.dataFields.category = 'category'
  pieSeries.dataFields.value = 'value'

  // Initial animation
  pieSeries.hiddenState.properties.opacity = 1
  pieSeries.hiddenState.properties.endAngle = -90
  pieSeries.hiddenState.properties.startAngle = -90

  // Labels
  pieSeries.labels.template.disabled = true
  pieSeries.ticks.template.disabled = true

  // Tooltip
  pieSeries.tooltip.getFillFromObject = false
  pieSeries.tooltip.background.fill = am4core.color('white')
  pieSeries.tooltip.autoTextColor = false
  pieSeries.tooltip.label.fill = am4core.color('black')

  // Slices
  pieSeries.slices.template.strokeWidth = 0
}

export const pieChartConfiguration = (graphic, isEmpty, data, colorList) => {
  const color = isEmpty ? [am4core.color(emptyPieColor)] : colorList.map(color => am4core.color(color))

  let chart = am4core.create(graphic, am4charts.PieChart)
  chart.data = data
  chart.innerRadius = am4core.percent(55)

  let pieSeries = chart.series.push(new am4charts.PieSeries())
  setPieSeries(pieSeries)

  // Tooltip
  pieSeries.slices.template.tooltipText = isEmpty ? '' : '{value}%'

  // Slices
  pieSeries.colors.list = color

  // Hover effect
  let hoverState = pieSeries.slices.template.states.getKey('hover')
  hoverState.transitionDuration = 500
  hoverState.properties.scale = isEmpty ? 1 : 1.1

  // Active status
  let activeState = pieSeries.slices.template.states.getKey('active')
  activeState.properties.shiftRadius = 0
}
